var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.flag)?_c('div',{staticClass:"container"},[_c('button',{staticClass:"scan",on:{"click":_vm.scanCode}},[_vm._v("扫一扫")]),(_vm.isScaning)?_c('div',{staticClass:"reader-box"},[_c('div',{staticClass:"reader",attrs:{"id":"reader"}})]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }